import React, { useContext, useEffect, useState } from "react";
import "./checkout.scss";
import { useParams } from "react-router";
import httpclient from "../../service/httpclient";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { faAlipay, faWeixin } from "@fortawesome/free-brands-svg-icons";
import { Input, Modal, notification, Space, Tooltip } from "antd";
import OrderService from "../../service/orderservice";
import CouponCard from "../../components/CouponCard/coupon-card";
import { CouponStatus } from "../user_center/contents/my_coupons/coupon-enums";
import { LoadingOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { isNull } from "lodash";
import {
  clearLotterySharePurchaseAttribution,
  getTodayLotterySharePurchaseAttribution,
} from "../../utils/lotteryShareAttribution";

import { UserContext } from "../../App";

function CheckOut(props) {
  const { userInfo, updateUserInfo } = useContext(UserContext);
  const [testpaperData, setTestpaperData] = useState(null);
  const [testpaperCollectionData, setTestpaperCollectionData] = useState(null);
  const [zhuanlansData, setZhuanlansData] = useState(null);
  const [categoriesData, setCategroiesData] = useState(null);
  const [recruitmentQuestionListData, setRecruitmentQuestionListData] =
    useState(null);
  const [productMembershipData, setProductMembershipData] = useState(null);
  const [streamingSeriesData, setStreamingSeriesData] = useState(null);
  const [streamingStreamData, setStreamingStreamData] = useState(null);

  const [paymentChoice, setPaymentChoice] = useState("wechat");
  const [renewSelect, setRenewSelect] = useState(0);
  const [couponsData, setCouponsData] = useState(null);
  const [selectedCoupons, setSelectedCoupons] = useState([]);
  const [calculatedPrice, setCalculatedPrice] = useState(null);
  const [isFirstPurchase, setIsFirstPurchase] = useState(false);
  const [recommendCode, setRecommendCode] = useState(null); //新人引荐码
  const [promotionCode, setPromotionCode] = useState(null); //优惠码
  const [isRecommend, setIsRecommend] = useState(null); //是否享受新人引荐优惠
  const [isPromotion, setIsPromotion] = useState(null); //是否享受优惠码优惠
  const [isDiscount, setIsDiscount] = useState(false); //是否享受推荐课程优惠
  const dataid = useParams().dataid;
  const datatype = useParams().datatype;
  const mode = useParams().mode;
  const isStreamingProduct =
    datatype === "streaming_series" || datatype === "streaming_stream";
  const isRecruitmentQuestionMembership =
    datatype === "product_memberships" && String(dataid) === "1";
  const supportsCoupons = true;
  const supportsPromotionCode =
    !isStreamingProduct && isRecruitmentQuestionMembership;
  const supportsRecommendDiscount =
    !isStreamingProduct && datatype !== "product_memberships";
  const orderservice = new OrderService();
  const [priceData, setPriceData] = useState(null);
  const renewMode = {
    0: 1,
    1: 2,
    2: 3,
  };
  const handleSelectCoupon = (array) => {
    setSelectedCoupons(array);
  };
  const effectiveSelectedCoupons = supportsCoupons ? selectedCoupons : [];

  const checkRecommendCode = (code) => {
    if (code.length === 6 && isFirstPurchase) {
      setRecommendCode(code);
    } else{
      setRecommendCode(null);
      setIsRecommend(null);
    }
  };


  const checkPromotionCode = (code) => {
    if (code.length === 8) {
      setPromotionCode(code);
    } else{
      setPromotionCode(null);
      setIsPromotion(null);
    }
  };

  useEffect(() => {
    setCalculatedPrice(null);
    httpclient
      .getCalculatedPrice(
        dataid,
        datatype,
        mode === "renew" ? renewMode[renewSelect] : null,
        effectiveSelectedCoupons,
        supportsRecommendDiscount && !promotionCode ? recommendCode : null,
        supportsPromotionCode ? promotionCode : null
      )
      .then((res) => {
        if (res?.price !== null) {
          setCalculatedPrice(res?.price);
        }

        // 引荐
        if (res?.isRecommend !== null) {
          setIsRecommend(res?.isRecommend);
          if (
            ((res?.isRecommend === true && isFirstPurchase) ||
              (supportsRecommendDiscount && isDiscount)) &&
            effectiveSelectedCoupons.length > 0
          ) {
            setSelectedCoupons([]);
          }
        }

        //优惠
        if (res?.isPromotion !== null) {
          setIsPromotion(res?.isPromotion);
          if (res?.isPromotion === true) {
            setIsRecommend(null);
            if (
              effectiveSelectedCoupons.length > 0 ||
              (supportsRecommendDiscount && isDiscount)
            ) {
              setSelectedCoupons([]);
            }
          }
        }

      });
  }, [selectedCoupons, dataid, datatype, renewSelect, recommendCode, promotionCode]);
  useEffect(() => {
    httpclient.getCoupons().then((res) => {
      if (res) {
        setCouponsData(res);
      }
    });
    httpclient.checkIsFirstPurchase().then((res) => {
      setIsFirstPurchase(res?.result);
    });
  }, []);

  useEffect(() => {
    if (selectedCoupons.length > 0 && couponsData) {
      const currentRenewMode = mode === "renew" ? renewMode[renewSelect] : null;
      const stillValid = selectedCoupons.every(couponId => {
        const coupon = couponsData.find(item => item.id === couponId);
        if (!coupon) return false;
        const ruleDSL = JSON.parse(coupon.detail.rule);
        return !ruleDSL.renew_only || currentRenewMode;
      });
      if (!stillValid) {
        setSelectedCoupons([]);
        notification.warning({
          message: "优惠券已失效",
          description: "您选择的优惠券不适用于当前购买模式",
        });
      }
    }
  }, [renewSelect, mode]);
  useEffect(() => {
    if (zhuanlansData) {
      httpclient.checkDiscount(zhuanlansData?.zhuanlan?.id).then((res) => {
        if (res) setIsDiscount(res?.result && mode !== "renew");
      });
    }
  }, [zhuanlansData]);
  useEffect(() => {
    if (datatype === "testpaper_collection") {
      httpclient.getTestPaperCollectionData(dataid).then((response) => {
        setTestpaperCollectionData(response);
        let pricedata = [
          response.price_1_month,
          response.price_6_month,
          response.price_12_month,
        ];
        setPriceData(pricedata);
      });
    } else if (datatype === "testpaper") {
      httpclient.getTestPaperData(dataid).then((response) => {
        setTestpaperData(response.testpaper);
      });
    } else if (datatype === "zhuanlans") {
      httpclient.getZhuanlansData(dataid).then((response) => {
        setZhuanlansData(response);
        let pricedata = [
          response.zhuanlan.price_1_month,
          response.zhuanlan.price_6_month,
          response.zhuanlan.price_12_month,
        ];
        setPriceData(pricedata);
      });
    } else if (datatype === "categories") {
      httpclient.getCategoriesData(dataid).then((response) => {
        setCategroiesData(response);
        let pricedata = [
          response.category.price_1_month,
          response.category.price_6_month,
          response.category.price_12_month,
        ];
        setPriceData(pricedata);
      });
    } else if (datatype === "recruitment_question_lists") {
      httpclient
        .getOneRecruitmentQuestionListWithQuestionInfo(dataid)
        .then((response) => {
          setRecruitmentQuestionListData(response);
        });
    } else if (datatype === "product_memberships") {
      httpclient.getOneProductMembership(dataid).then((response) => {
        setProductMembershipData(response);
        let pricedata = [
          response.price_1_month,
          response.price_6_month,
          response.price_12_month,
        ];
        setPriceData(pricedata);
      });
    } else if (datatype === "streaming_series") {
      httpclient.getStreamingSeriesData(dataid).then((response) => {
        setStreamingSeriesData(response);
      });
    } else if (datatype === "streaming_stream") {
      httpclient.getStreamingStreamData(dataid).then((response) => {
        setStreamingStreamData(response);
      });
    }
  }, [dataid, datatype]);

  const streamingSeriesPurchaseMode =
    streamingSeriesData?.purchaseMode ||
    "normal";
  const streamingStreamPurchaseMode =
    streamingStreamData?.purchaseMode ||
    "normal";
  const isStreamingStreamSeriesOnly =
    datatype === "streaming_stream" &&
    !streamingStreamData?.allowStreamPurchase;
  const isStreamingVoucherOnly =
    (datatype === "streaming_series" &&
      streamingSeriesPurchaseMode === "voucher_only") ||
    (datatype === "streaming_stream" &&
      (
        streamingStreamPurchaseMode === "voucher_only" ||
        (streamingStreamData?.seriesPurchaseMode || "normal") === "voucher_only"
      ));
  const effectiveIsPromotion = supportsPromotionCode ? isPromotion : null;
  const effectiveIsRecommend = supportsRecommendDiscount ? isRecommend : null;
  const effectiveIsDiscount = supportsRecommendDiscount ? isDiscount : false;
  const effectiveRecommendCode = effectiveIsRecommend ? recommendCode : null;
  const effectivePromotionCode = effectiveIsPromotion ? promotionCode : null;

  function buildProductForOrder(id) {
    const product = {
      id: id,
      type: datatype,
      renew_price_mode: mode === "renew" ? renewMode[renewSelect] : null,
      coupons: effectiveSelectedCoupons,
      recommend_code: effectiveRecommendCode,
      promotion_code: effectivePromotionCode,
    };

    if (datatype === "product_memberships" && String(id) === "1" && mode !== "renew") {
      const lotteryShareKey = getTodayLotterySharePurchaseAttribution();
      if (lotteryShareKey) {
        product.lottery_share_key = lotteryShareKey;
      }
    }

    return product;
  }

  function clearLotteryShareAttributionAfterOrder(product) {
    if (product?.lottery_share_key) {
      clearLotterySharePurchaseAttribution();
    }
  }

  function doBuy(id) {
    if (isStreamingStreamSeriesOnly) {
      Modal.info({
        content: "该直播场次不支持单场解锁，请购买整套直播课程。",
        okType: "ghost",
        okText: "查看整套课程",
        onOk: function () {
          if (streamingStreamData?.seriesId) {
            window.location = `/streaming/series/${streamingStreamData.seriesId}`;
            return;
          }
          window.location = "/streaming";
        },
      });
      return;
    }

    if (isStreamingVoucherOnly) {
      Modal.info({
        content: "该直播内容仅支持站内激活，请返回直播页面解锁。",
        okType: "ghost",
        okText: "确定",
        onOk: function () {
          window.location = "/streaming";
        },
      });
      return;
    }

    if (datatype === "testpaper_collection") {
      httpclient.possessTestpaperCollection(id, false).then((response) => {
        if (response) {
          if (response.result === true && mode !== "renew") {
            Modal.info({
              content: "您已购买此试卷集合",
              okType: "ghost",
              okText: "确定",
              onOk: function () {
                window.location = `/${datatype}/${dataid}`;
              },
            });
          } else if (
            (mode === "renew" &&
              (response.time_expired || response.result === true)) ||
            mode !== "renew"
          ) {
            httpclient.deleteOpenid().then(() => {
              orderservice
                .order(
                  {
                    id: id,
                    type: datatype,
                    renew_price_mode:
                      mode === "renew" ? renewMode[renewSelect] : null,
                    coupons: effectiveSelectedCoupons,
                    recommend_code: effectiveRecommendCode,
                    promotion_code: effectivePromotionCode
                  },
                  { jumpBackUrl: `/${datatype}/${dataid}` }
                )
                .then();
            });
          } else {
            Modal.info({
              content: "您尚未购买过此试卷集合，没有续费资格",
              okType: "ghost",
              okText: "确定",
              onOk: function () {
                window.location = `/checkout/${datatype}/${dataid}`;
              },
            });
          }
        }
      });
    } else if (datatype === "testpaper") {
      httpclient.possessTestpaper(id).then((response) => {
        if (response) {
          if (response.result === true && mode !== "renew") {
            Modal.info({
              content: "您已购买此试卷",
              okType: "ghost",
              okText: "确定",
              onOk: function () {
                window.location = `/${datatype}/${dataid}`;
              },
            });
          } else {
            httpclient.deleteOpenid().then(() => {
              orderservice
                .order(
                  {
                    id: id,
                    type: datatype,
                    coupons: effectiveSelectedCoupons,
                    recommend_code: effectiveRecommendCode,
                    promotion_code: effectivePromotionCode
                  },
                  { jumpBackUrl: `/${datatype}/${dataid}` }
                )
                .then();
            });
          }
        }
      });
    } else if (datatype === "zhuanlans") {
      httpclient.possessZhuanlan(id, false).then((response) => {
        if (response) {
          if (response.result === true && mode !== "renew") {
            Modal.info({
              content: "您已购买此专栏",
              okType: "ghost",
              okText: "确定",
              onOk: function () {
                window.location = `/${datatype}/${dataid}`;
              },
            });
          } else if (
            (mode === "renew" &&
              (response.time_expired || response.result === true)) ||
            mode !== "renew"
          ) {
            httpclient.deleteOpenid().then(() => {
              orderservice
                .order(
                  {
                    id: id,
                    type: datatype,
                    renew_price_mode:
                      mode === "renew" ? renewMode[renewSelect] : null,
                    coupons: effectiveSelectedCoupons,
                    recommend_code: effectiveRecommendCode,
                    promotion_code: effectivePromotionCode
                  },
                  { jumpBackUrl: `/${datatype}/${dataid}` }
                )
                .then();
            });
          } else {
            Modal.info({
              content: "您尚未购买过此专栏，没有续费资格",
              okType: "ghost",
              okText: "确定",
              onOk: function () {
                window.location = `/checkout/${datatype}/${dataid}`;
              },
            });
          }
        }
      });
    } else if (datatype === "categories") {
      httpclient.possessCategory(id, false).then((response) => {
        if (response) {
          if (response.result === true && mode !== "renew") {
            Modal.info({
              content: "您已购买此合集",
              okType: "ghost",
              okText: "确定",
              onOk: function () {
                window.location = `/${datatype}/${dataid}`;
              },
            });
          } else if (
            (mode === "renew" &&
              (response.time_expired || response.result === true)) ||
            mode !== "renew"
          ) {
            httpclient.deleteOpenid().then(() => {
              orderservice
                .order(
                  {
                    id: id,
                    type: datatype,
                    renew_price_mode:
                      mode === "renew" ? renewMode[renewSelect] : null,
                    coupons: effectiveSelectedCoupons,
                    recommend_code: effectiveRecommendCode,
                    promotion_code: effectivePromotionCode
                  },
                  { jumpBackUrl: `/${datatype}/${dataid}` }
                )
                .then();
            });
          } else {
            Modal.info({
              content: "您尚未购买过此合集，没有续费资格",
              okType: "ghost",
              okText: "确定",
              onOk: function () {
                window.location = `/checkout/${datatype}/${dataid}`;
              },
            });
          }
        }
      });
    } else if (datatype === "recruitment_question_lists") {
      httpclient.possessRecruitmentQuestionList(id, false).then((response) => {
        if (response) {
          if (response.result === true && mode !== "renew") {
            Modal.info({
              content: "您已购买此题单",
              okType: "ghost",
              okText: "确定",
              onOk: function () {
                window.location = `/${datatype}/${dataid}`;
              },
            });
          } else if (
            (mode === "renew" &&
              (response.time_expired || response.result === true)) ||
            mode !== "renew"
          ) {
            httpclient.deleteOpenid().then(() => {
              orderservice
                .order(
                  {
                    id: id,
                    type: datatype,
                    renew_price_mode:
                      mode === "renew" ? renewMode[renewSelect] : null,
                    coupons: effectiveSelectedCoupons,
                    recommend_code: effectiveRecommendCode,
                    promotion_code: effectivePromotionCode
                  },
                  { jumpBackUrl: `/${datatype}/${dataid}` }
                )
                .then();
            });
          } else {
            Modal.info({
              content: "您尚未购买过此题单，没有续费资格",
              okType: "ghost",
              okText: "确定",
              onOk: function () {
                window.location = `/checkout/${datatype}/${dataid}`;
              },
            });
          }
        }
      });
    } else if (datatype === "product_memberships") {
      httpclient.possessProductMembership(id, false).then((response) => {
        if (response) {
          if (response.result === true && mode !== "renew") {
            Modal.info({
              content: "您已购买此会员",
              okType: "ghost",
              okText: "确定",
              onOk: function () {
                window.location = productMembershipData?.jump_back_url;
              },
            });
          } else if (
            (mode === "renew" &&
              (response.time_expired || response.result === true)) ||
            mode !== "renew"
          ) {
            httpclient.deleteOpenid().then(() => {
              const product = buildProductForOrder(id);
              orderservice
                .order(
                  product,
                  { jumpBackUrl: productMembershipData?.jump_back_url }
                )
                .then(() => clearLotteryShareAttributionAfterOrder(product));
            });
          } else {
            Modal.info({
              content: "您尚未购买过此题单，没有续费资格",
              okType: "ghost",
              okText: "确定",
              onOk: function () {
                window.location = `/checkout/${datatype}/${dataid}`;
              },
            });
          }
        }
      });
    } else if (datatype === "streaming_series" || datatype === "streaming_stream") {
      httpclient.deleteOpenid().then(() => {
        const streamingReturnUrl = localStorage.getItem('streaming_purchase_return_url');
        orderservice
          .order(
            {
              id: id,
              type: datatype,
              renew_price_mode: null,
              coupons: effectiveSelectedCoupons,
              recommend_code: effectiveRecommendCode,
              promotion_code: effectivePromotionCode,
            },
            { jumpBackUrl: streamingReturnUrl || "/streaming" }
          )
          .then(() => {
            if (streamingReturnUrl) {
              localStorage.removeItem('streaming_purchase_return_url');
            }
          });
      });
    }
  }
  return (
    <div className="checkout-wrapper">
      <img className="fab fa-alipay"></img>
      <div className="checkout">
        <div className="checkout-title">
          支付{mode === "renew" && <span>（续费）</span>}
        </div>
        <div className="section">
          {!!testpaperData && (
            <div className="testpaper-info">
              <div className="info-title">试卷信息</div>
              <span className="testpaper-title">{testpaperData.title}</span>
              <span className="testpaper-price">
                价格: {testpaperData.price / 100}
              </span>
            </div>
          )}
          {!!testpaperCollectionData && (
            <div className="testpaper-collection-info">
              <div className="info-title">试卷集合信息</div>
              <span className="testpaper-title">
                {testpaperCollectionData.name}
              </span>
              <span className="testpaper-price">
                {mode === "renew" ? <span>原</span> : <span>总</span>}价:{" "}
                {testpaperCollectionData.price / 100}
              </span>
              <div className="testpaper-collection-intro">
                {testpaperCollectionData.introduction_text}
              </div>
            </div>
          )}
          {!!zhuanlansData && (
            <div className="zhuanlan-info">
              <div className="info-title">专栏信息</div>
              <span className="testpaper-title">
                {zhuanlansData.zhuanlan.name}
              </span>
              <span className="testpaper-price">
                {mode === "renew" ? <span>原</span> : <span>总</span>}价:{" "}
                {zhuanlansData.zhuanlan.price / 100}
              </span>
              <div className="testpaper-collection-intro">
                {zhuanlansData.zhuanlan.introduction_html}
              </div>
            </div>
          )}
          {!!categoriesData && (
            <div className="category-info">
              <div className="info-title">合集信息</div>
              <span className="testpaper-title">
                {categoriesData.category.name}
              </span>
              <span className="testpaper-price">
                {mode === "renew" ? <span>原</span> : <span>总</span>}价:{" "}
                {categoriesData.category.price / 100}
              </span>
              <div className="testpaper-collection-intro">
                {categoriesData.category.introduction_html}
              </div>
            </div>
          )}
          {!!recruitmentQuestionListData && (
            <div className="recruitment-question-list-info">
              <div className="info-title">题单信息</div>
              <Space size="large" style={{ fontSize: 16, margin: "10px 0" }}>
                <span>{recruitmentQuestionListData.title}</span>
                <span>定价：{recruitmentQuestionListData.price / 100}元</span>
              </Space>
              <div>{recruitmentQuestionListData.description}</div>
              <div style={{ marginTop: 24 }}>
                购买后解锁题单内所有题目的视频解答。
              </div>
              <div className="attention">
                若该题单内的题目后续增加新的视频解答，在商品有效期内的用户均可直接观看
              </div>
            </div>
          )}
          {!!productMembershipData && (
            <div className="product-membership-info">
              <div className="info-title">会员信息</div>
              <Space size="middle" style={{ fontSize: 16, margin: "10px 0" }}>
                <span>{productMembershipData.name}</span>
                <span>定价:{productMembershipData.price / 100}元</span>
                {productMembershipData.calculated_price !==
                  productMembershipData.price && (
                  <span>
                    优惠价:{productMembershipData.calculated_price / 100}元
                  </span>
                )}
              </Space>
              <div>开通会员后，可观看所有题库内题目的视频解答。</div>
              <div className="attention">
                若题库中的题目后续增加新的视频解答，在商品有效期内的用户均可直接观看
              </div>
            </div>
          )}
          {!!streamingSeriesData && (
            <div className="streaming-series-info">
              <div className="info-title">直播课程信息</div>
              <Space size="large" style={{ fontSize: 16, margin: "10px 0" }}>
                <span>{streamingSeriesData.title}</span>
                <span>定价：{streamingSeriesData.price ?? "待定"}元</span>
              </Space>
              {streamingSeriesData.description && (
                <div>{streamingSeriesData.description}</div>
              )}
            </div>
          )}
          {!!streamingStreamData && (
            <div className="streaming-stream-info">
              <div className="info-title">直播单场信息</div>
              <Space size="large" style={{ fontSize: 16, margin: "10px 0" }}>
                <span>{streamingStreamData.title}</span>
                <span>定价：{streamingStreamData.price ?? "待定"}元</span>
              </Space>
            </div>
          )}
          {mode === "renew" && priceData && (
            <div className="renew-select">
              <div className="renew-select-title">请选择续费时长</div>
              <div className="renew-select-item-wrapper">
                <div
                  className="renew-select-item"
                  onClick={() => {
                    setRenewSelect(0);
                  }}
                >
                  一个月 {priceData[0] / 100}{" "}
                  {renewSelect === 0 && <FontAwesomeIcon icon={faCheck} />}
                </div>
                <div
                  className="renew-select-item"
                  onClick={() => {
                    setRenewSelect(1);
                  }}
                >
                  六个月 {priceData[1] / 100}{" "}
                  {renewSelect === 1 && <FontAwesomeIcon icon={faCheck} />}
                </div>
                <div
                  className="renew-select-item"
                  onClick={() => {
                    setRenewSelect(2);
                  }}
                >
                  一年 {priceData[2] / 100}{" "}
                  {renewSelect === 2 && <FontAwesomeIcon icon={faCheck} />}
                </div>
              </div>
            </div>
          )}
          {mode === "renew" ? (
            <div className="attention">
              注意：续费商品有效期为选择的使用期限时长，期限内可反复观看
            </div>
          ) : (
            <div className="attention">
              注意：商品有效期为购买日起之后的一年，一年内可反复观看
            </div>
          )}
        </div>
        <div className="section">
          <div className="payment-wrapper">
            {!isStreamingVoucherOnly && !isStreamingStreamSeriesOnly ? (
              <>
                <div className="payment-title">选择支付方式</div>
                <span
                  className="wechat-button"
                  onClick={() => {
                    setPaymentChoice("wechat");
                  }}
                >
                  微信
                  <FontAwesomeIcon className="pay-icon" icon={faWeixin} />
                  {paymentChoice === "wechat" && <FontAwesomeIcon icon={faCheck} />}
                </span>
                {/*<span*/}
                {/*  className="alipay-button"*/}
                {/*  onClick={() => {*/}
                {/*    setPaymentChoice("alipay");*/}
                {/*  }}*/}
                {/*>*/}
                {/*  支付宝 <FontAwesomeIcon className="pay-icon" icon={faAlipay} />*/}
                {/*  {paymentChoice === "alipay" && <FontAwesomeIcon icon={faCheck} />}*/}
                {/*</span>*/}
                <div>
                  <div
                    className="payment-title"
                    style={{ marginTop: "20px", marginBottom: "0" }}
                  >
                    选择优惠券
                  </div>
                  {supportsCoupons && !!couponsData && (
                    <CouponCard
                      disable={
                        (effectiveIsRecommend && isFirstPurchase) ||
                        effectiveIsDiscount ||
                        effectiveIsPromotion
                      }
                      price={calculatedPrice}
                      dataType={datatype}
                      dataId={dataid}
                      handleClick={handleSelectCoupon}
                      type="checkbox"
                      cardData={couponsData?.filter(
                        (item) => item.status === CouponStatus.AVAILABLE
                      )}
                      renewMode={mode === "renew" ? renewMode[renewSelect] : null}
                    />
                  )}

                  

                  {supportsPromotionCode && (
                    <div>
                      <div
                        className="payment-title"
                        style={{ marginBottom: "10px", display: "flex" }}
                      >
                        优惠码
                        <div style={{ marginLeft: "5px" }}>
                          <Tooltip title="优惠码不可与优惠券或引荐码同时使用">
                            <QuestionCircleOutlined />
                          </Tooltip>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        优惠码：
                        <Input
                          style={{ width: "100px" }}
                          maxLength={8}
                          placeholder="请输入优惠码"
                          onChange={(e) => {
                            checkPromotionCode(e.target.value);
                          }}
                          size="small"
                        />
                        {!isNull(effectiveIsPromotion) &&
                        (effectiveIsPromotion === true ? (
                          <div
                            style={{
                              marginLeft: "10px",
                              color: "green",
                              fontSize: "12px",
                              opacity: "0.6",
                            }}
                          >
                            合法优惠码
                          </div>
                        ) : (
                          <div
                            style={{
                              marginLeft: "10px",
                              color: "red",
                              fontSize: "12px",
                              opacity: "0.6",
                            }}
                          >
                            无效优惠码
                          </div>
                        ))}
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          color: "darkgrey",
                          marginTop: "10px",
                        }}
                      ></div>
                    </div>
                  )}

                  {supportsRecommendDiscount && !!isFirstPurchase && (
                    <div>
                      <div
                        className="payment-title"
                        style={{ marginBottom: "10px", display: "flex" }}
                      >
                        引荐优惠{" "}
                        <div style={{ marginLeft: "5px" }}>
                          <Tooltip title="成功引荐，被引荐人可享5折优惠，引荐人可获得50元抵用券">
                            <QuestionCircleOutlined />
                          </Tooltip>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        引荐码：
                        <Input
                          disabled={!!effectiveIsPromotion}
                          style={{ width: "100px" }}
                          maxLength={6}
                          placeholder="请输入引荐码"
                          onChange={(e) => {
                            checkRecommendCode(e.target.value);
                          }}
                          size="small"
                        />
                        {!isNull(effectiveIsRecommend) &&
                          (effectiveIsRecommend === true ? (
                            <div
                              style={{
                                marginLeft: "10px",
                                color: "green",
                                fontSize: "12px",
                                opacity: "0.6",
                              }}
                            >
                              合法引荐码
                            </div>
                          ) : (
                            <div
                              style={{
                                marginLeft: "10px",
                                color: "red",
                                fontSize: "12px",
                                opacity: "0.6",
                              }}
                            >
                              无效引荐码
                            </div>
                          ))}
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          color: "darkgrey",
                          marginTop: "10px",
                        }}
                      >
                        注：引荐优惠仅限引荐人已购买过网站商品，且被引荐人为首次购买时才可生效；引荐优惠不可与优惠券同时使用
                      </div>
                    </div>
                  )}

                </div>
                <div className="payment-info">
                  {calculatedPrice !== null ? (
                    `您需要支付￥${calculatedPrice / 100}`
                  ) : (
                    <span>
                      <LoadingOutlined
                        style={{ color: "#5995DA", marginRight: "10px" }}
                      />
                      正在为您计算价格...
                    </span>
                  )}
                  {isFirstPurchase && effectiveIsRecommend && (
                    <span
                      style={{
                        marginLeft: "10px",
                        color: "green",
                        fontSize: "12px",
                        opacity: "0.6",
                      }}
                    >
                      已享5折优惠，不可使用其他优惠券
                    </span>
                  )}
                  {!!effectiveIsDiscount && (
                    <span
                      style={{
                        marginLeft: "10px",
                        color: "green",
                        fontSize: "12px",
                        opacity: "0.6",
                      }}
                    >
                      {" "}
                      该专栏已享受推荐课程5折优惠,不可使用其他优惠券
                    </span>
                  )}
                </div>
              </>
            ) : (
              <>
                <div className="payment-title">
                  {isStreamingStreamSeriesOnly ? "购买方式" : "兑换方式"}
                </div>
                <div className="payment-info">
                  {isStreamingStreamSeriesOnly
                    ? "该直播场次不支持单场解锁，请返回直播课程页购买整套直播课程。"
                    : "该直播内容仅支持兑换券激活，请返回直播页面使用账户中的直播兑换券解锁。"}
                </div>
              </>
            )}
            <span
              className="buy-button button-primary"
              style={
                isStreamingVoucherOnly || isStreamingStreamSeriesOnly
                  ? { opacity: 0.6, cursor: "not-allowed" }
                  : undefined
              }
              onClick={() => {
                doBuy(dataid);
              }}
            >
              {isStreamingStreamSeriesOnly
                ? "请购买整套课程"
                : isStreamingVoucherOnly
                  ? "仅支持兑换券激活"
                  : "确认购买"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CheckOut;
